import { render, staticRenderFns } from "./NLPAnalysisResult.vue?vue&type=template&id=7ddc1165&scoped=true&"
import script from "./NLPAnalysisResult.vue?vue&type=script&lang=js&"
export * from "./NLPAnalysisResult.vue?vue&type=script&lang=js&"
import style0 from "./NLPAnalysisResult.vue?vue&type=style&index=0&id=7ddc1165&prod&lang=css&"
import style1 from "./NLPAnalysisResult.vue?vue&type=style&index=1&id=7ddc1165&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ddc1165",
  null
  
)

export default component.exports